import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { ILogiAsResultVm } from '../logi-as-result-vm.model';
import { ILoginAsIm } from '../login-as-im.model';
@Injectable({ providedIn: 'root' })
export class LoginAsParamService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/LoginAsParam`;
  }
  post(loginAsIm: ILoginAsIm): Observable<ILogiAsResultVm> {
    const headers = this.createHeaders();
    return this.http.post<ILogiAsResultVm>(this.baseUrl, loginAsIm, { headers });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
